<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)">
</app-ship-details>

<app-round-trip-overview
  *ngIf="shipRoundTripHistory"
  [ship]="ship"
  [shipRoundTripHistory]="shipRoundTripHistory"
  [shipInstallations]="shipInstallations"
  [lastEOMDetails]="lastEOMDetails"
  #roundTripOverview>
</app-round-trip-overview>

<app-fleet-information
  *ngIf="ship"
  [ship]="ship"
  #fleetInformation
  (shipDataChange)="onShipChange($event)">
</app-fleet-information>

<app-round-trip-history
  *ngIf="ship && shipRoundTripHistory"
  [ship]="ship"
  [shipRoundTripHistory]="shipRoundTripHistory"
  [shipInstallations]="shipInstallations"
  #roundTripHistory>
</app-round-trip-history>
